import { render, staticRenderFns } from "./BlockEditorDefault.vue?vue&type=template&id=5c764c82&"
import script from "./BlockEditorDefault.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports